import { AuthUser, NOT_ADMIN_PERMISSION } from "../models/auth-user.model";
import { JoinOperator, RequiredPermissions } from "../models/permission.model";

export class PermissionHelper {

  static evaluatePermission(requiredPermissions: RequiredPermissions, user: AuthUser) {

    if (user.isAdmin()) {
      return requiredPermissions.permissions ? !requiredPermissions.permissions.find(perm => perm === NOT_ADMIN_PERMISSION) : true;
    }

    if(requiredPermissions.joinOperator === JoinOperator.AND) {
      return requiredPermissions.permissions.every(perm => user.hasPermission(perm) || (perm === NOT_ADMIN_PERMISSION));
    }

    if(requiredPermissions.joinOperator === JoinOperator.OR) {
      return requiredPermissions.permissions
        .filter(perm => perm !== NOT_ADMIN_PERMISSION)
        .some(perm => user.hasPermission(perm));
    }
  }
}
